import React from 'react';
import { EcommerceContextWrapper } from '@blaze-cms/ecommerce-context';
import { CampaignProvider } from 'blaze-kelsey-plugin-frontend-campaign';

export default function AppWrapper({ children }) {
  return (
    <EcommerceContextWrapper withCredentials enableAddressEmail>
      <CampaignProvider>{children}</CampaignProvider>
    </EcommerceContextWrapper>
  );
}
